__turbopack_context__.v({
  "body": "index-module-scss-module__sYitza__body",
  "footerButtons": "index-module-scss-module__sYitza__footerButtons",
  "landingButtons": "index-module-scss-module__sYitza__landingButtons",
});
